import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import CartScreen from "../Screen/Cart/CartScreen";
import Home from "../Screen/Home/Home";
import ProductScreen from "../Screen/Product/ProductScreen";
import RegisterScreen from "../Screen/Register/RegisterScreen";
import ShippingScreen from "../Screen/Shipping/ShippingScreen";
import SignInScreen from "../Screen/Signin/SigninScreen";
import Error404 from "../Screen/Error/Error404";
import PaymentScreen from "../Screen/Payment/PaymentScreen";
import PlaceOrderScreen from "../Screen/Order/PlaceOrderScreen";
import OrderScreen from "../Screen/Order/OrderScreen";
import OrderHistoryScreen from "../Screen/Order/OrderHistoryScreen";
import ProfileScreen from "../Screen/UserProfile/ProfileScreen";
import PrivateRoute from "../Components/PrivateRoute";

function Index() {
  return (
    <div>
      <BrowserRouter>
        <header>
          <Header />
        </header>
        <div className="myBodyContainer">
          <div className="mainBody">
            <Routes>
              <Route path="/" element={<Home />} exact></Route>
              <Route path="/signin" element={<SignInScreen />}></Route>
              <Route path="/shipping" element={<ShippingScreen />}></Route>
              <Route path="/register" element={<RegisterScreen />}></Route>
              <Route path="/cart" element={<CartScreen />}></Route>
              <Route path="/cart/:id" element={<CartScreen />}></Route>
              <Route path="/product/:id" element={<ProductScreen />}></Route>
              <Route path="/payment" element={<PaymentScreen />}></Route>
              <Route path="/placeorder" element={<PlaceOrderScreen />}></Route>
              <Route path="/orderhistory" element={<OrderHistoryScreen />}></Route>
              <Route path="/order/:id" element={<OrderScreen />}></Route>
              <Route path="/profile" element={<PrivateRoute><ProfileScreen /></PrivateRoute>}></Route>
              <Route path="*" element={<Error404 />} />
            </Routes>
          </div>
          <div className="myFooter">
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}
// 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
export default Index;
